import * as p from '@clack/prompts'
import type { ProjectPromptResult } from '@cli-types/next-adapter/init.js'

export async function promptProject(defaultName?: string): Promise<ProjectPromptResult> {
  const projectName = await p.text({
    message: 'What is your project named?',
    placeholder: defaultName ?? '(Press Enter to use default)',
    defaultValue: defaultName ?? '.',
    validate: (value) => {
      if (!value?.trim()) return undefined
      if (value.trim() === '.') return undefined
      if (!/^[a-z0-9_-]+$/i.test(value.trim())) {
        return 'Project name can only contain letters, numbers, hyphens, and underscores'
      }
      return undefined
    }
  })

  if (p.isCancel(projectName)) {
    p.cancel('Setup cancelled.')
    process.exit(0)
  }

  return { projectName: projectName.trim() || '.' }
}
